import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectPadraoComponent } from "app/components/compartilhados/select-padrao/select-padrao.component";
import { DataPickerPadraoComponent } from "app/components/compartilhados/data-picker-padrao/data-picker-padrao.component";
import { PadraoDatapicket, PadraoSelect } from 'app/interfaces/compartilhados/Inputs';
import { Cliente } from 'app/interfaces/Cliente';
import { Operacao, Operacoes } from 'app/interfaces/Operacao';
import { MapearDadosService } from 'app/services/mapear-dados/mapear-dados.service';
import { ClienteService } from 'app/services/cliente/cliente.service';
import { SolicitarExportacoesService } from 'app/services/solicitar-exportacoes/solicitar-exportacoes.service';
import { MapaService } from 'app/services/mapa/mapa.service';
import { MapaDisponivel } from 'app/interfaces/mapa';
import { SolicitacaoExportacao } from 'app/interfaces/SolicitacaoExportacao';
import { DialogService } from 'app/services/dialog/dialog.service';
import { tap } from 'rxjs';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

interface camposFiltros {
  clienteId?: number;
  operacaoId?: number;
  dataPicker?: PadraoDatapicket;
  tipoMapa?: 'muda_ton_ha' | 'muda_tol_m' | 'solido' | 'liquido' | 'profundidade'
  [key: string]: string | number | PadraoDatapicket | undefined
}

@Component({
  selector: 'app-exportar-mapas-calor',
  standalone: true,
  imports: [ReactiveFormsModule, SelectPadraoComponent, DataPickerPadraoComponent, TranslocoModule],
  templateUrl: './exportar-mapas-calor.component.html',
  styleUrl: './exportar-mapas-calor.component.css'
})
export class ExportarMapasCalorComponent implements OnInit {
  public dadosFiltro!: camposFiltros;
  public podeSubmeterFormulario: boolean = false;
  public listaClientes!: PadraoSelect[];
  public listaOperacoes!: PadraoSelect[];
  public listaTipoMapas: PadraoSelect[] = []

  constructor(
    private readonly mapearDadosService: MapearDadosService,
    private readonly clienteService: ClienteService,
    private readonly solicitarExportacoesService: SolicitarExportacoesService,
    private readonly mapaService: MapaService,
    private readonly dialogService: DialogService,
    private readonly translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.dadosFiltro = {
      dataPicker: undefined,
      operacaoId: undefined,
      clienteId: undefined,
      tipoMapa: undefined
    }
    this.buscarDadosSelect();
  }

  public buscarDadosSelect(): void {
    this.buscarListaCliente();
  }

  public buscarListaCliente(): void {
    let dadosCliente = JSON.parse(sessionStorage.getItem('clientes')!);
    const mapObj = {
      'nome': 'label'
    }
    this.pegarDados(null, 'operacaoId');
    this.listaClientes = this.mapearDadosService.mapearDadosArray<Cliente, PadraoSelect>(dadosCliente, mapObj, true);
  }

  public buscarListaOperacao(clienteId: number): void {
    this.clienteService.buscarTodasOperacoes(clienteId).subscribe(
      (operacoes: Operacoes) => {
        this.pegarDados(null, 'tipoMapa');
        let mapObj = {
          'sr_id': 'id',
          'vc_service_id': 'label'
        }
        this.listaOperacoes = this.mapearDadosService.mapearDadosArray<Operacao, PadraoSelect>(operacoes, mapObj, false);
      }
    );
  }

  public buscarListaMapasDisponiveis(clienteId: number, operacaoId: number): void {
    this.mapaService.buscarMapasDisponiveis(clienteId, operacaoId)
      .subscribe(
        (mapasDisponiveis) => {
          const mapObj: any = {
            "tipo": 'id'
          }
          const mapaDados = this.mapearDadosService.mapearDadosArray<MapaDisponivel, PadraoSelect>(mapasDisponiveis, mapObj, false);
          this.listaTipoMapas = this.obterLabelsTipoMapa(mapaDados);
        });
  }

  public obterLabelsTipoMapa(tipoMapasObj: PadraoSelect[]): any {
    tipoMapasObj.forEach(tipo => {
      const key = `COMPONENTS.MAPA.DIALOGS.MAP_TYPE.types.${tipo.id}`;
      const translated = this.translocoService.translate(key);
      tipo.label = translated !== key ? translated : tipo.label;
    });
    return tipoMapasObj;
  }

  public onSubmit(): void {
    const exportacao: SolicitacaoExportacao = {
      dt_inicio: (this.dadosFiltro.dataPicker?.dataInicio || new Date()).toISOString().split('T')[0],
      dt_fim: (this.dadosFiltro.dataPicker?.dataFim || (new Date((d => (d.setMonth(d.getMonth() + 3), d))(new Date())))).toISOString().split('T')[0],
      js_filtros: { it_operacao: this.dadosFiltro.operacaoId!, en_tipo_mapa: this.dadosFiltro.tipoMapa! },
      it_cliente: this.dadosFiltro.clienteId!,
      vc_email: this.obterEmailUsuario!,
      tipo: 'mapa_calor'
    }

    this.dialogService.loading('Solicitando exportação, por favor aguarde...')
    this.solicitarExportacoesService.solicitarExportacao(exportacao).pipe(
      tap({
        next: () => this.dialogService.fechar(),
        error: () => this.dialogService.fechar(),
      })
    ).subscribe({
      next: (res: any) => this.dialogService.sucesso('Sucesso', res.mensagem),
      error: () => this.dialogService.erro('Erro', 'Erro interno no servidor, tente novamente mais tarde.')
    });

  }

  public verificarForm(): void {
    this.podeSubmeterFormulario = Object.values(this.dadosFiltro).every(v => !!v);
  }

  public pegarDadosCliente(dados: string | null, campo: string) {
    if (dados) {
      this.buscarListaOperacao(Number(dados))
    } else {
      this.dadosFiltro['operacaoId'] = undefined;
      this.listaOperacoes = []
      this.listaTipoMapas = []
    }
    this.pegarDados(dados, campo);
  }

  public pegarDadosOperacao(dados: string | null, campo: string) {
    if (dados) {
      this.buscarListaMapasDisponiveis(this.dadosFiltro.clienteId!, Number(dados))
    } else {
      this.dadosFiltro['tipoMapa'] = undefined;
      this.listaTipoMapas = []
    }
    this.pegarDados(dados, campo);
  }

  public pegarDados(dados: any, campo: string) {
    this.dadosFiltro[campo] = dados;
    this.verificarForm();
  }

  get obterEmailUsuario() {
    return localStorage.getItem('usuarioLogin')
  }
}
